// Strip any [PLACEHOLDER …] marker so developer text can never reach a caregiver.
export function stripPlaceholder(text) {
    if (!text) return "";
    if (!text.includes("[PLACEHOLDER")) return text.trim();
    console.warn("Missing founder copy — placeholder marker stripped before render.");
    return text.replace(/\[PLACEHOLDER[^\]]*\]\s*/g, "").trim();
}
